import React, {Component} from 'react';
import styled from 'styled-components/macro'


const StyledRuler = styled.div`
  position: absolute;
  border: 2px solid #FD7575;
  top: ${props => props.top};
  left: ${props => props.left};
  width: ${props => props.width};
  height: ${props => props.height};
  display: flex;
  justify-content: center;
  align-items: center;
`

const Width = styled.div`
  position: absolute;
  bottom: -32px;
  color: #FD7575;
`

const Height = styled.div`
  transform: rotate(90deg);
  position: absolute;
  right: -48px;
  color: #FD7575;
`

class Ruler extends Component{

  getBorders(){
    let borders = {
      left: 0,
      top:0,
      right: 0,
      bottom: 0
    };

    this.props.objects.forEach((obj,i) => {
      let {x, y} = obj.position;
      let {width, height} = obj.size;

      if(i === 0){
        borders.left = x;
        borders.top = y;
        borders.right = x + width;
        borders.bottom = y + height;
      }
      else{
        borders.left > x && ( borders.left = x );
        borders.top > y && ( borders.top = y );
        borders.right < x + width && ( borders.right = x + width );
        borders.bottom < y + height && ( borders.bottom = y + height );
      }
    });

    return borders;
  }

  render(){
    let {top, left, right, bottom} = this.getBorders();
    let width = right - left + 2;
    let height = bottom - top + 2;
    return(
      <StyledRuler
        top={top + 'px'}
        left={left + 'px'}
        width={width + 'px'}
        height= {height + 'px'}
      >
        <Width>{width-2 + ' px'}</Width>
        <Height>{height-2 + ' px'}</Height>
      </StyledRuler>
    )
  }
}

export default Ruler;